import React, { Component } from "react";
import moment from "moment";
import get from "lodash/get";
import size from "lodash/size";
import ceil from "lodash/ceil";
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import has from "lodash/has";
import { deepClone } from "../../../utils/copyObject";
import { calculateIndexRange } from "../../../utils/dashboardUtils";
import Paginations from "../../../components/Pagination/Pagination";
import If from "../../../components/Shared/If";
import {
  sortArray,
  sortDatesArray,
  sortNumbersArray,
  sortOfficeArray,
  sortEnterpriseArray,
} from "../../../components/Shared/ReusablesUtils";
import "../Analytics.css";
import NoDataFound from "../../../assets/no-kpidata-range.png";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { Modal, ModalBody, ModalHeader, Table } from "reactstrap";

class UsersGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adminSortOrder: "desc",
      gridPagination: {
        defaultRecord: 10,
        currentPage: 1,
        recordCount: 10,
      },
      userAnalytics:
        this.props.userAnalytics && size(this.props.userAnalytics.length) > 0
          ? deepClone(this.props.userAnalytics)
          : [],
      searchKey:
        this.props.searchObject && !isEmpty(this.props.searchObject.usernname)
          ? get(this.props.searchObject, "username", "")
          : "",
      userGroupsModal: {
        open: false,
        data: [],
      },
    };
  }
  componentWillReceiveProps(nextProps) {
    const { searchKey } = this.state;
    if (nextProps.searchObject.username !== searchKey) {
      this.setState({
        gridPagination: {
          ...this.state.gridPagination,
          currentPage: 1,
          defaultRecord: 10,
          recordCount: 10,
        },
      });
    }
    this.setState({ userAnalytics: nextProps.userAnalytics });
  }

  handleOpenUserGroupsModal = (user) => {
    
    const modalData = user.groups.map(x => {
       const groupName = user.metrics && user.metrics.groupsJoined &&  user.metrics.groupsJoined.find(g => g.groupId == x.o_id )
        return {
            date_joined:x.date_joined,
            name:groupName.name
        }
    })

    this.setState({
        userGroupsModal:{
            open:true,
            data:modalData
        }
    })

        
  };

  handleCloseUserGroupsModal=()=>{
      this.setState({
          userGroupsModal:{
              open:false,
              data:[]
          }
      })
  }

  getKeyValue = (object) => {
    const rowsArray = [];
    for (const [index, [key, value]] of Object.entries(
      Object.entries(object.metrics)
    )) {
      if (key != "usersCreated") {
        const tdData = object.metrics[key] instanceof Array &&
        typeof object.metrics[key] !== undefined
          ? object.metrics[key].length
          : 0
        rowsArray.push(
          <td key={key} className={tdData && key=="groupsJoined"?"group-data-notation":""} onClick={()=>key=="groupsJoined"? this.handleOpenUserGroupsModal(object) :null} >
            {tdData}
          </td>
        );
      }
    }
    return rowsArray;
  };
  getColumnName = (columnName) => {
    const { userMetrices } = this.props;
    console.log("userMetrices--", userMetrices);
    const columnDetails = userMetrices.filter((e) => e.id === columnName);
    return !isEmpty(columnDetails) ? columnDetails[0].name : "";
  };
  getUserName = (item) => {
    if (!isEmpty(item.firstName) || !isEmpty(item.lastName)) {
      return `${item.firstName} ${item.lastName}`;
    }
    return "NA";
  };
  getMetricsDynamicHeader = (data) => {
    console.log("getMetricsDynamicHeader", data);
    const headersArray = [];
    for (let key in data) {
      if (data.hasOwnProperty(key) && key != "usersCreated") {
        headersArray.push(
          <th key={key} scope="col" className="bottom-border-color borderTop0">
            <span className="table-sort-title">{this.getColumnName(key)}</span>
            <span
              onClick={this.sortDynamicMetrics}
              sortkey={key}
              className="table-sort-icon pull-right fa fa-sort"
            ></span>
          </th>
        );
      }
    }
    return headersArray;
  };
  sortByOfficeName = () => {
    let adminSortOrder;
    if (this.state.adminSortOrder === "asc") {
      adminSortOrder = "desc";
    } else {
      adminSortOrder = "asc";
    }
    this.setState({ adminSortOrder }, () => {
      const updatedList = sortOfficeArray(
        this.props.userAnalytics,
        this.state.adminSortOrder
      );
      this.setState({ userAnalytics: updatedList });
    });
  };

  sortDynamicMetrics = (event) => {
    const key = event.target.getAttribute("sortkey");
    let adminSortOrder;
    if (this.state.adminSortOrder === "asc") {
      adminSortOrder = "desc";
    } else {
      adminSortOrder = "asc";
    }
    this.setState({ adminSortOrder }, () => {
      const updatedList = sortNumbersArray(
        this.props.userAnalytics,
        key,
        this.state.adminSortOrder
      );
      this.setState({ userAnalytics: updatedList });
    });
  };
  sortDates = (sortKey) => {
    let adminSortOrder;
    if (this.state.adminSortOrder === "asc") {
      adminSortOrder = "desc";
    } else {
      adminSortOrder = "asc";
    }

    const sorted = [...this.props.userAnalytics].sort((a, b) => {
      const dateA =
        sortKey == "invited"
          ? new Date(a.date_invited || a.createDate)
          : new Date(a.date_joined || a.createDate);
      const dateB =
        sortKey == "invited"
          ? new Date(b.date_invited || b.createDate)
          : new Date(b.date_joined || b.createDate);

      return adminSortOrder === "asc" ? dateA - dateB : dateB - dateA;
    });
    this.setState({ adminSortOrder }, () => {
      const updatedList = sorted;
      this.setState({ userAnalytics: updatedList });
    });
  };
  sortUserName = (key) => {
    console.log("sort---", this.props.userAnalytics);
    let adminSortOrder;
    if (this.state.adminSortOrder === "asc") {
      adminSortOrder = "desc";
    } else {
      adminSortOrder = "asc";
    }
    this.setState({ adminSortOrder }, () => {
      const updatedList = sortArray(
        this.props.userAnalytics,
        key,
        this.state.adminSortOrder
      );
      this.setState({ userAnalytics: updatedList });
    });
  };
  handlePageNavigation = (nextOrPrevious) => {
    if (nextOrPrevious === "previous" || nextOrPrevious === "next") {
      this.setState({
        gridPagination: {
          ...this.state.gridPagination,
          currentPage:
            nextOrPrevious === "previous"
              ? parseInt(this.state.gridPagination.currentPage - 1)
              : parseInt(this.state.gridPagination.currentPage + 1),
        },
      });
    } else {
      this.setState({
        gridPagination: {
          ...this.state.gridPagination,
          currentPage: parseInt(nextOrPrevious),
        },
      });
    }
  };

  handleRecordCountChange = (event) => {
    const { value } = event.target;
    const {
      gridPagination: { recordCount },
    } = this.state;
    this.setState({
      gridPagination: {
        ...this.state.gridPagination,
        recordCount: parseInt(value),
        totalPage: ceil(size(this.state.userAnalytics) / recordCount),
      },
    });
  };
  generatePageNumbers = (userAnalytics) => {
    const { currentPage, recordCount } = this.state.gridPagination;
    let pageNumbers = [];

    if (recordCount > size(userAnalytics)) {
      pageNumbers = [];
    } else {
      for (let i = 1; i <= ceil(size(userAnalytics) / recordCount); i++) {
        pageNumbers.push(
          <li key={i} className="page-item">
            <span
              className={
                currentPage === i ? "page-link currentpage-active" : "page-link"
              }
              onClick={() => this.handlePageNavigation(i)}
            >
              {i}
            </span>
          </li>
        );
      }
    }
    // Slice only 1 to 10 Page
    const pageNumbersInitial = pageNumbers.slice(0, 10);
    return pageNumbersInitial;
  };

  renderList = (list) => {
    if (list && list.length > 0) {
      console.log("rendder----", list);
      return list.map((item, index) => {
        const invitedDate = item.date_invited
          ? item.date_invited
          : item.createDate;
        const joinedDate = item.date_joined? item.date_joined : item.sso && item.sso[0] && item.sso[0].date ? item.sso[0].date : item.createDate;

        const isJoined = item.date_joined || item.isPasswordChanged || (item.sso && item.sso[0] && item.sso[0].date )

        return (
          <tr key={index}>
            <td>{this.getUserName(item)}</td>
            <td>{!isEmpty(item.email) ? item.email : "NA"}</td>
            <td>{moment(invitedDate).format("MM/DD/YYYY")}</td>
            <td>{isJoined ? moment(joinedDate).format("MM/DD/YYYY"):"-"}</td>
            <td>
              {item.isDeleted == "true"
                ? "Removed"
                : item.isPasswordChanged
                ? "Joined"
                : "Invited"}
            </td>
            <td>{!isEmpty(item.role) ? item.role : "NA"}</td>
            <td>{!isEmpty(item.title) ? item.title : "NA"}</td>
            <td>{!isEmpty(item.office) ? item.office : "NA"}</td>
            {/* <td>{!isEmpty(item.organization) ? item.organization : 'NA'}</td> */}
            {has(item, "metrics") ? this.getKeyValue(item) : null}
          </tr>
        );
      });
    }
    return (
      <tr>
        <td>No record found</td>
      </tr>
    );
  };
  render() {
    // Handling Pagination with Javsascript slice method.
    const { userAnalytics,userGroupsModal } = this.state;
    const {
      gridPagination: { currentPage, recordCount },
    } = this.state;
    let test = calculateIndexRange(currentPage, recordCount);
    const slicedRecords = userAnalytics.slice(test.begin, test.end);
    const totalPageNumber = ceil(size(userAnalytics) / recordCount);
    let nodatafound = null;

    if (userAnalytics && userAnalytics.length === 0) {
      nodatafound = (
        <div className="text-center no-data-available-desc">
          <p style={{ marginBottom: "0px" }}>
            Looks like there's no data available for the parameters you
            selected.
          </p>
          <p> Try adjusting your filters, dates.</p>
          <img src={NoDataFound} className="no-kpi-date-range" />
        </div>
      );
    }

    return (
      <div>
          {
             userGroupsModal && userGroupsModal.open ? <Modal isOpen={userGroupsModal.open}>
                <ModalHeader toggle={this.handleCloseUserGroupsModal}>
                   Groups
                </ModalHeader>
                <ModalBody className="p-3">
                   <Table>
                       <thead>
                           <tr>
                               <th>Name</th>
                               <th>Date Joined</th>
                           </tr>
                       </thead>
                       <tbody>
                           {
                               userGroupsModal.data && userGroupsModal.data.map(x=>{
                               console.log("klklkllk",x)
                                return <tr>
                                    <td>{x.name}</td>
                                    <td>
                                        {moment(x.date_joined).format("MM/DD/YYYY")}
                                    </td>
                                </tr>
                               })
                           }
                       </tbody>
                   </Table>
                </ModalBody>
             </Modal> : null
          }
        {userAnalytics.length > 0 && (
          <div>
            <div className="row p-0 m-0 mt-3 mb-2 table-responsive-sm table-ellipsis">
              <table
                className="toolkit-list table text-primary-color tool-list-font"
                style={{ borderTop: "0px" }}
              >
                <thead>
                  <tr className="col-sm-4 mb-3">
                    <th scope="col" className="bottom-border-color borderTop0">
                      <span className="table-sort-title">Name</span>
                      <span
                        onClick={() => this.sortUserName("firstName")}
                        className="table-sort-icon pull-right fa fa-sort"
                      ></span>
                    </th>
                    <th scope="col" className="bottom-border-color borderTop0">
                      <span className="table-sort-title">Email</span>
                      <span
                        onClick={() => this.sortUserName("email")}
                        className="table-sort-icon pull-right fa fa-sort"
                      ></span>
                    </th>
                    <th scope="col" className="bottom-border-color borderTop0">
                      <span className="table-sort-title">Invited</span>
                      <span
                        onClick={() => this.sortDates("invited")}
                        className="table-sort-icon pull-right fa fa-sort"
                      ></span>
                    </th>
                    <th scope="col" className="bottom-border-color borderTop0">
                      <span className="table-sort-title">Joined</span>
                      <span
                        onClick={() => this.sortDates("joined")}
                        className="table-sort-icon pull-right fa fa-sort"
                      ></span>
                    </th>
                    <th scope="col" className="bottom-border-color borderTop0">
                      <span className="table-sort-title">User Status</span>
                      <span
                        onClick={() => this.sortUserName("isDeleted")}
                        className="table-sort-icon pull-right fa fa-sort"
                      ></span>
                    </th>
                    <th scope="col" className="bottom-border-color borderTop0">
                      <span className="table-sort-title">Role</span>
                      <span
                        onClick={() => this.sortUserName("role")}
                        className="table-sort-icon pull-right fa fa-sort"
                      ></span>
                    </th>
                    <th scope="col" className="bottom-border-color borderTop0">
                      <span className="table-sort-title">Position</span>
                      <span
                        onClick={() => this.sortUserName("title")}
                        className="table-sort-icon pull-right fa fa-sort"
                      ></span>
                    </th>
                    <th scope="col" className="bottom-border-color borderTop0">
                      <span className="table-sort-title">Office</span>
                      <span
                        onClick={() => this.sortByOfficeName()}
                        className="table-sort-icon pull-right fa fa-sort"
                      ></span>
                    </th>
                    {this.getMetricsDynamicHeader(
                      get(slicedRecords[0], "metrics", [])
                    )}
                  </tr>
                </thead>
                <tbody>{this.renderList(slicedRecords)}</tbody>
              </table>
            </div>
            <If condition={size(userAnalytics) > 0}>
              <Paginations
                currentPage={currentPage}
                totalPageNumber={totalPageNumber}
                handlePageNavigation={this.handlePageNavigation}
                Analytics={userAnalytics}
                generatePageNumbers={this.generatePageNumbers}
                handleRecordCountChange={this.handleRecordCountChange}
                recordCount={recordCount}
                totalRecords={size(userAnalytics)}
              />
            </If>
          </div>
        )}
        {nodatafound}
      </div>
    );
  }
}

UsersGrid.propTypes = {
  userAnalytics: PropTypes.array,
  searchObject: PropTypes.object,
  userMetrices: PropTypes.object,
};

export default UsersGrid;
